/* LPV1 lander: CTA links, sticky bar, gallery, accordions, how-to video. No libraries. */
(function () {
  'use strict';
  var d = document;
  function all(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  var IO = 'IntersectionObserver' in window;

  // CTAs: "#offer" scrolls; any other link keeps the visitor's query string (UTMs, fbclid, pdp).
  // "view" is never copied: it only picks this page's template and would replace the link's own ?view=.
  all('[data-lp-cta]').forEach(function (a) {
    var h = a.getAttribute('href') || '';
    if (h.charAt(0) === '#') {
      a.addEventListener('click', function (e) {
        var t = h.length > 1 && d.querySelector(h);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
      return;
    }
    if (!location.search) return;
    try {
      var u = new URL(h, location.href);
      new URLSearchParams(location.search).forEach(function (v, k) { if (k !== 'view') u.searchParams.set(k, v); });
      a.href = u.href;
    } catch (e) {}
  });

  // sticky bar: slides down once the hero button has scrolled out of view
  var bar = d.querySelector('[data-lp-sbar]');
  var heroCta = d.querySelector('[data-lp-hero-cta]');
  function setBar(on) {
    bar.classList.toggle('is-shown', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    all('a', bar).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
  }
  if (bar) {
    if (heroCta && IO) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        setBar(!e.isIntersecting && e.boundingClientRect.bottom < 0);
      }).observe(heroCta);
    } else if (!heroCta) { setBar(true); }
  }

  // gallery: arrows, thumbnails, swipe (native scroll-snap)
  all('[data-lp-gal]').forEach(function (g) {
    var t = g.querySelector('.lp-gtrack');
    if (!t) return;
    var th = all('.lp-gth button', g);
    function idx() { return Math.round(t.scrollLeft / t.clientWidth); }
    function go(i) {
      i = Math.max(0, Math.min(t.children.length - 1, i));
      t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' });
    }
    t.addEventListener('scroll', function () {
      var i = idx();
      th.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }, { passive: true });
    var p = g.querySelector('.lp-ga--p'), n = g.querySelector('.lp-ga--n');
    if (p) p.addEventListener('click', function () { go(idx() - 1); });
    if (n) n.addEventListener('click', function () { go(idx() + 1); });
    th.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
  });

  // accordions: closed on load, one open at a time per group
  all('[data-lp-accs]').forEach(function (grp) {
    var acc = all('details', grp);
    acc.forEach(function (x) {
      x.addEventListener('toggle', function () {
        if (x.open) acc.forEach(function (o) { if (o !== x) o.open = false; });
      });
    });
  });

  // how-to video: muted, starts when it scrolls into view, never stops
  all('video[data-lp-autoplay]').forEach(function (v) {
    v.muted = true;
    function play() { var r = v.play(); if (r && r.catch) r.catch(function () {}); }
    if (!IO) { play(); return; }
    var ob = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { play(); ob.disconnect(); }
    }, { threshold: 0.25 });
    ob.observe(v);
  });
})();
